module.exports = __webpack_public_path__ + "static/media/egg-icon.da4246c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/egg-icon.svg
// module id = 594
// module chunks = 11